/* Контракт лежит в репозитории: CI собирает только этот проект,
   соседний checkout steos-bot-service в контекст Docker не попадает. */
import contract from './miniapp-routes.v1.json';

export interface MiniAppRoute {
  readonly key: string;
  readonly title: string;
  readonly section: string;
  readonly screen?: string;
  readonly mode?: string;
  readonly out?: string;
  readonly tool?: string;
  readonly sheet?: string;
  /** Отбор списка раздела: 's2s' — «Озвучка» только с голосами для переозвучки записи */
  readonly filter?: string;
}

const routes: ReadonlyMap<string, MiniAppRoute> = new Map(contract.routes.map(route => [route.key, Object.freeze({ ...route })]));

/** Untrusted navigation hints are safe only after an exact allow-list lookup.
 * Identity, gifts, referrals and money always require server verification. */
export function resolveMiniAppLaunch(raw: string): MiniAppRoute | null {
  if (!raw.startsWith('go_')) return null;
  return routes.get(raw.slice(3)) ?? null;
}

export function applyMiniAppLaunch(raw: string): boolean {
  const route = resolveMiniAppLaunch(raw);
  if (!route) return false;
  window.dispatchEvent(new CustomEvent('steos:miniapp-route', { detail: route }));
  return true;
}
